Ext.define('SA.data.Tree', {
    singleton: true,

    getChildFolders(parent, location) {
        return SA.Ajax.request({
            resource: 'attributes/tree',
            data: {parent, filterLocation: location || undefined}
        });
    },

    getRootFolders(datasetSeriesId, edition, censusRelease, location) {
        return SA.Ajax.request({
            resource: 'attributes/tree',
            data: {datasetSeriesId, edition, censusRelease, filterLocation: location || undefined}
        });
    }
});